import { INewObjectSimilarAndBuilderSchema } from '../../repositories/monolith-python/entities/schemas/NewObjectSimilarAndBuilderSchema';
import { ISimilarNewobject } from '../../types/similarNewobjects';
import { IGetSimilarAndBuilderNewObjectsResponseSchema84 } from 'shared/repositories/monolith-python/entities/schemas/GetSimilarAndBuilderNewObjectsResponseSchema84';

export function prepareSimilarNewobjects(
  response: IGetSimilarAndBuilderNewObjectsResponseSchema84,
): ISimilarNewobject[] {
  if (!response.data.newobjects) {
    return [];
  }

  return response.data.newobjects.map(prepareSimilarNewobjectsItem);
}

function prepareSimilarNewobjectsItem(newobject: INewObjectSimilarAndBuilderSchema): ISimilarNewobject {
  return {
    ...newobject,
    priceDisplay: newobject.priceDisplay || '',
    addressDisplay: newobject.addressDisplay || '',
    imageUrl: newobject.imageUrl || '',
    fullUrl: newobject.fullUrl || '',
    undergroundInfo: {
      ...newobject.undergroundInfo,
      name: newobject.undergroundInfo?.name || '',
      lineColor: newobject.undergroundInfo?.lineColor || '',
      timeDisplay: newobject.undergroundInfo?.timeDisplay || '',
    },
    buildersDisplay: newobject.buildersDisplay || null,
    minPrice: newobject.minPrice || 0,
    statusDisplay: newobject.statusDisplay || '',
  };
}
